/**
 * @file Spin
 * @author WenCe
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class Spin extends PureComponent {
    static propTypes = {
        size: PropTypes.number
    }

    static defaultProps = {
        size: 0.8
    }

    render() {
        const size = this.props.size;
        const rem = `${size}rem`;
        const style = {width: rem, height: rem};

        return (
            <div className="spin-wrapper">
                <div className="spin" style={style}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Spin/index.js